import React, { Component } from 'react';
import { compose } from 'redux'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'
import withAuth from '../../components/withAuth';
import QuotesFilters from '../../components/Quotes/QuotesFilters'
import { getCurrentFunctionName } from '../../performanceModeManager';
import QuotesList from '../../components/Quotes/QuotesList';
import QuotesCounters from '../../components/Quotes/QuotesCounters';
import { setFilteredAndSortedQuotes } from '../../redux/quote/quoteActions';
import moment from "moment";
import { formatStatus, getColorFromStatusLabel } from '../../redux/quote/quoteStatus';
import QuoteStatusIcon from '../../components/Quotes/QuoteStatusIcon';
import { formatType } from '../../redux/quote/quoteTypes';
import { formatAmountToString, mobileAndTabletCheck } from '../../utils';

class Quotes extends Component {

    constructor(props) {
        super(props);

        if (!this.props.quotesFilters.displayAsList || mobileAndTabletCheck())//Chargement déjà effectué par le composant table
            this.props.setFilteredAndSortedQuotes(this.props.quotesFilters, this.props.tableState,
                this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);

        this.state = {
            columns: [
                {
                    Header: "Date",
                    width: 150,
                    id: 'date_quote_asked',
                    accessor: a => moment(a.date_quote_asked).format("DD/MM/YYYY"),
                },
                {
                    Header: "Code",
                    width: 120,
                    accessor: "code",
                },
                {
                    Header: "Type",
                    id: 'quote_type',
                    accessor: q => formatType(q.quote_type),
                    minWidth: 100,
                    maxWidth: 200,
                },
                {
                    Header: "Affaire",
                    id: 'created_affair_id',
                    accessor: q => q.created_affair_id ? q.created_affair_id : "",
                    minWidth: 100,
                    maxWidth: 200,
                },
                {
                    Header: "Statut",
                    id: 'quote_state',
                    accessor: q => formatStatus(q.state),
                    Cell: (cellInfo) => {
                        let currentQuote = this.props.quotesFilters.filteredAndSortedQuotes.filter((a) => !a.deleted)[cellInfo.index];
                        if (!currentQuote)
                            return null;

                        return (
                            <>
                                <QuoteStatusIcon state={currentQuote.state} />
                                <span className={"status-icon-color-" + getColorFromStatusLabel(currentQuote.state)} >
                                    {formatStatus(currentQuote.state)}
                                </span>
                            </>
                        )
                    },
                    minWidth: 100,
                    maxWidth: 200,
                },
                {
                    id: 'current_market_amount',
                    Header: "Montant",
                    minWidth: 100,
                    maxWidth: 200,
                    accessor: q => q.current_market_amount ? formatAmountToString(q.current_market_amount) : ''
                },
                {
                    Header: "Description",
                    accessor: "name",
                    minWidth: 120,
                    maxWidth: 800
                },
            ]
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.sites.selectedSite !== this.props.sites.selectedSite)
            this.props.setFilteredAndSortedQuotes(this.props.quotesFilters, this.props.tableState,
                this.props.activeUser, this.props.sites.selectedSite, this.props.sites.sites, this.props.tableState.nbTotalResults);
    }

    render() {
        console.perfLog(getCurrentFunctionName());

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding-only-small-screen">
                <QuotesFilters quotesFilters={this.props.quotesFilters} />
                <QuotesCounters columns={this.state.columns} />
                <QuotesList columns={this.state.columns} globalContainer={this.props.globalStore.container} quotesFilters={this.props.quotesFilters}
                    filteredAndSortedQuotes={this.props.quotesFilters.filteredAndSortedQuotes} />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        activeUser: state.activeUser,
        quotesFilters: state.quotes,
        sites: state.sites,
        tableState: state.tableState,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setFilteredAndSortedQuotes: (quotesFilters, tableState, user, customerSiteId, allSites, nbTotalResults) =>
            dispatch(setFilteredAndSortedQuotes(quotesFilters, tableState, user, customerSiteId, allSites, nbTotalResults)),
    };
};

export default compose(withAuth, withRouter, connect(mapStateToProps, mapDispatchToProps))(Quotes);
